/**
 * @flow
 * Created by neo on 05.03.17.
 */
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import PolyLinePath from './PolyLinePath';
import Config from '../../Config/index';
import FlightRoute from '../../Store/Flight/FlightRoute';
import Language from '../../../lang';

type Props = {
  params: any,
  route: FlightRoute,
  zoom?: number,
  center?: {
    lat: number,
    lng: number,
  },
};

@observer
export default class FlightRouteMap extends React.Component<Props, void> {
  @observable map: any;
  @observable maps: any;
  @observable mapLoaded: boolean = false;

  static defaultProps = {
    center: { lat: 46.9650572, lng: 8.3817774 },
    zoom: 8,
  };



  getCenterAndZoom() {
    const { props: { route: { points } } } = this;
    if (points.length > 0 && this.maps) {
      const bounds = new this.maps.LatLngBounds();

      for (var i = 0; i < points.length; i++) {
        bounds.extend({
          lat: +points[i].gps_lat,
          lng: +points[i].gps_long
        });
      }

      return fitBounds({
        ne: bounds.getNorthEast().toJSON(),
        sw: bounds.getSouthWest().toJSON()
      }, {
        width: 300,
        height: 300
      });
    }

    return {
      center: this.props.center,
      zoom: this.props.zoom
    };
  }

  handleMapLoaded = ({ map, maps }: any) => {
    this.map = map;
    this.maps = maps;
    this.mapLoaded = true;
  };

  render() {
    const { mapLoaded, map, maps, props: { route: { points } } } = this;
    const {
      center,
      zoom
    } = this.getCenterAndZoom();

    return (
      <div className="map">
        <GoogleMapReact
          style={{ height: '100%' }}
          center={center}
          zoom={zoom}
          bootstrapURLKeys={{ key: Config.googleMapsApiKey, language: Language.lang, region: 'ch' }}
          onGoogleApiLoaded={this.handleMapLoaded}
          yesIWantToUseGoogleMapApiInternals={true}
        >
          {mapLoaded && (
            <PolyLinePath map={map} maps={maps} locations={points} />
          )}
        </GoogleMapReact>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/Map/index.js